define('views/modules/calendar/calendar/summary/summary-tables/summary-table',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // views
    'views/modules/calendar/calendar/summary/summary-tables/summary-header',
    'views/modules/calendar/calendar/summary/summary-tables/summary-rows',
    // Templates
    'text!templates/modules/calendar/calendar/summary/summary-tables/summary-table.html',
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // views
    VSummaryHeader,
    VSummaryRows,
    // templates
    TSummaryTable
) {

    var VSummaryTable = Backbone.View.extend({
        template: TSummaryTable,

        regions: {
            root: ".summary-table",
            header: "table thead",
            rows: "table tbody"
        },

        initialize: function(opt) {
            opt = this.options = opt || {};

            this.view = {
                header: new VSummaryHeader({
                    model: this.model,
                    headers: opt.headers,
                    context: this
                }),
                rows: new VSummaryRows({
                    rows: opt.rows,
                    rowType: opt.type,
                    context: this
                })
            };
        },

        render: function() {

            // Render HTML template
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            // caching element into this.zone
            this.generateZones()
                .assign(this.view.header, this.zone.$header)
                .assign(this.view.rows, this.zone.$rows);

            return this;
        },

    });

    return VSummaryTable;
});

